module.exports = __webpack_public_path__ + "img/HR.4f10323f.svg";